import { render, staticRenderFns } from "./dollar-circle.vue?vue&type=template&id=f60106fe&"
import script from "./dollar-circle.vue?vue&type=script&lang=js&"
export * from "./dollar-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60106fe')) {
      api.createRecord('f60106fe', component.options)
    } else {
      api.reload('f60106fe', component.options)
    }
    module.hot.accept("./dollar-circle.vue?vue&type=template&id=f60106fe&", function () {
      api.rerender('f60106fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/dollar-circle.vue"
export default component.exports